/**
 * Preview Entry Point
 * 
 * Initializes the notification bar preview
 * 
 * @package TopBuddy
 */

import { createRoot } from '@wordpress/element';
import App from './App';
import './style.scss';

const previewRoot = document.getElementById('topbuddy-preview-root');

if (previewRoot) {
	const root = createRoot(previewRoot);
	root.render(<App />);
}
